var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{attrs:{"navbar-menu-classes":"navbar-left"}},[_c('div',[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticStyle:{"display":"inline"},attrs:{"src":_vm.logo,"alt":"Kobotrack"}}),_vm._v(" Kobotrack")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }